<template>
  <section class="content checkout-content d-flex justify-content-center pt-0 wp_MarginBottomAllPage">
    <!--<div class="row">-->
    <!--<div class="col-12 margin-adjustment col-lg-6 ml-2 p-3 my-4 card">-->
    <!--<form class="form-signin">-->
    <!--<h1 class="h3 mb-3 font-weight-normal">-->
    <!--Sign In-->
    <!--</h1>-->
    <!--<label for="inputEmailContent" class="sr-only">-->
    <!--Name-->
    <!--</label>-->
    <!--<input type="text" id="inputEmailContent"-->
    <!--class="form-control"-->
    <!--placeholder="Name"-->
    <!--required=""-->
    <!--autofocus=""-->
    <!--&gt;-->
    <!--<label for="inputEmail" class="sr-only"-->
    <!--&gt;-->
    <!--Email address-->
    <!--</label>-->
    <!--<input type="email" id="inputEmail"-->
    <!--class="form-control"-->
    <!--placeholder="Email address"-->
    <!--required=""-->
    <!--autofocus=""-->
    <!--&gt;-->
    <!--<label for="inputPassword" class="sr-only"-->
    <!--&gt;-->
    <!--Password-->
    <!--</label>-->
    <!--<input type="password"-->
    <!--id="inputPassword"-->
    <!--class="form-control"-->
    <!--placeholder="Password"-->
    <!--required=""-->
    <!--&gt;-->
    <!--<div class="radio">-->
    <!--<div class="form-check">-->
    <!--<input class="form-check-input"-->
    <!--type="radio"-->
    <!--name="exampleRadios"-->
    <!--id="exampleRadios1"-->
    <!--value="option1"-->
    <!--checked-->
    <!--&gt;-->
    <!--<label class="form-check-label" for="exampleRadios1"-->
    <!--&gt;-->
    <!--Male-->
    <!--</label>-->
    <!--</div>-->
    <!--<div class="form-check ml-3">-->
    <!--<input class="form-check-input"-->
    <!--type="radio"-->
    <!--name="exampleRadios"-->
    <!--id="exampleRadios2"-->
    <!--value="option2"-->
    <!--&gt;-->
    <!--<label class="form-check-label" for="exampleRadios2">-->

    <!--Female-->
    <!--</label>-->
    <!--</div>-->
    <!--</div>-->
    <!--<select class="custom-select">-->
    <!--<label>Country</label>-->
    <!--<option selected>Select Country</option>-->
    <!--<option value="1">Kuwait</option>-->
    <!--<option value="2">Bahrin</option>-->
    <!--<option value="3">UAE</option>-->
    <!--</select>-->
    <!--<input type="text" name="" id=""-->
    <!--class="form-control"-->
    <!--placeholder="Phone"-->
    <!--aria-describedby="helpId"-->
    <!--&gt;-->
    <!--<div class="checkbox mb-3">-->
    <!--<label>-->
    <!--<input type="checkbox" value="remember-me">-->
    <!--Remember me-->
    <!--</label>-->
    <!--</div>-->
    <!--<button class="btn btn-lg btn-primary btn-block-->
    <!--btn-outline-secondary"-->
    <!--type="submit"-->
    <!--&gt;-->
    <!--Sign Up-->
    <!--</button>-->
    <!--&lt;!&ndash;<a href=""><label for="forgotpswd">-->
    <!--Forgot Password ?-->
    <!--</label>-->
    <!--</a>&ndash;&gt;-->
    <!--</form>-->
    <!--</div>-->
    <!--</div>-->
    <!--<sign-up-form></sign-up-form>-->

    <div class="clientauth-wrapper mt-5">
      <div id="accordion">
        <div class="card">
          <div
            class="card-header"
            id="headingOne"
          >
            <h5 class="mb-0"
																data-test="signUpHeading">
              <button
                class="btn"
																style="font-weight: bold; cursor: default"
																data-test="signUpBtn"
																id="signUpBtn"
              >
<!--                <input-->
<!--                  type="radio"-->
<!--                  id="test2"-->
<!--                  name="radio-group"-->
<!--                  checked-->
<!--																		data-test="signUpRadio"-->
<!--                >-->
<!--                <label for="test2"-->
<!--																							data-test="signUpLabel">-->
                  Sign Up
<!--                </label>-->
              </button>
            </h5>
          </div>
          <div
            id="collapseOne"
            class="collapse show"
            aria-labelledby="headingOne"
            data-parent="#accordion"
          >
            <div
              class="card-body"
              v-show="!(signUpFormSubmitted && !optVerified)"
            >
													<sign-up-form
														:accountData="account"
														@signUpFormSubmit="signUpSubmitAction($event)"
														:loading="loading"
													/>
													<hr>
              <p class="mt-2 mb-0 signupquery"
																	data-test="signUpAlreadyHead"
																	id="signUpAlreadyHead">
                Already have an Account?
                <router-link :to="($route.query.next_to)?{path:'/login', query: {next_to: $route.query.next_to}}:'/login'"
																													data-test="signUpLoginLink"
																													id="signUpLoginLink">
                  Login
                </router-link>
              </p>
														<p class="mt-2 mb-0 signupquery"
															data-test="signUpAlreadyHead">
															Are you a Bank Customer?
															<router-link :to="($route.query.next_to)?{path:'/bank-login', query: {next_to: $route.query.next_to}}:'/bank-login'"
																												data-test="signUpLoginLink">
																Register
															</router-link>
              </p>
            </div>
            <div
              class="card-body"
              v-show="(signUpFormSubmitted && !optVerified)"
            >
              <p
                class="text-left"
                id="sign-up-verification-para"
																data-test="signUpOtpTextPara"
              >
                Please enter verification code (OTP) sent to:
              </p>
													<verify-otp-form
														:formData=verifyOptFormData
														@cancelOtp="signUpFormSubmitted = false"
														@resendOtp="checkOtpOptionAndSendOtp()"
														@verifyOtp="verifyOtp($event)"
														:loading="loading"
													/>
            </div>
          </div>
        </div>
        <!--<div class="card card-login">-->
        <!--<div class="card-header" id="headingTwo">-->
        <!--<h5 class="mb-0">-->
        <!--<button-->
        <!--class="btn btn-link collapsed"-->
        <!--data-toggle="collapse"-->
        <!--data-target="#collapseTwo"-->
        <!--aria-expanded="false"-->
        <!--aria-controls="collapseTwo"-->
        <!--&gt;-->
        <!--<input type="radio" id="test1" name="radio-group">-->
        <!--<label for="test1">Login</label>-->
        <!--</button>-->
        <!--</h5>-->
        <!--</div>-->
        <!--<div-->
        <!--id="collapseTwo"-->
        <!--class="collapse"-->
        <!--aria-labelledby="headingTwo"-->
        <!--data-parent="#accordion"-->
        <!--&gt;-->
        <!--<div class="card-body">-->
        <!--<login-form :buttonText="'Login'"-->
        <!--@loginSuccess="emitLoginSuccessEvent()"-->
        <!--&gt;-->
        <!--</login-form>-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
      </div>
    </div>

    <!-- <div class="modal-header">
            <h1 class="modal-title login-modal-title"
                id="exampleModalLongTitle"
            >
              Sign Up
            </h1>
          </div>
          <div class="modal-body login-modal-body" v-show="(!signUpFormSubmitted)">
            <p class="text-left" id="sign-up-para" >
              Please enter your details to Sign Up.
            </p>
            <sign-up-form :accountData=account
                          @signUpFormSubmit="signUpSubmitAction($event)"
                          :loading="loading"
            >
            </sign-up-form>
          </div>
          <div class="modal-body login-modal-body"
               v-show="(signUpFormSubmitted && !optVerified)"
          >
            <p class="text-left"  id="sign-up-verification-para">
              Please enter verification code (OTP) sent to:
            </p>
            <verify-otp-form :formData=verifyOptFormData
                             @cancelOtp="signUpFormSubmitted = false"
                             @resendOtp="checkOtpOptionAndSendOtp()"
                             @verifyOtp="verifyOtp($event)"
                             :loading="loading"
            >
            </verify-otp-form>
    </div> -->
  </section>
</template>

<script>
import { authenticationApi } from '@/services/ApiServices/authenticationApi'
import { mapGetters } from 'vuex'
import SignUpForm from './forms/SignUpForm'
import VerifyOtpForm from './forms/VerifyOtpForm'

export default {
	beforeMount () {
		if (this.isAuthenticated) {
			// this.$toasted.show('You are already login');
			this.$router.push('/')
			// if (this.$route.query.next_to === 'checkOut') {
			//
			//   this.$router.push({
			//     path: '/checkout',
			//   });
			// } else {
			//   this.$router.back();
			// }
			// this.$router.back();
		}
	},
	components: {
		VerifyOtpForm,
		SignUpForm
	},
	computed: {
		...mapGetters('user', ['isAuthenticated'])
	},
	data () {
		return {
			account: {
				firstname: '',
				lastname: '',
				username: '',
				password: '',
				phoneno: '',
				confirmPassword: '',
				checkbox: false,
				otpOption: 'phone',
				income_slab: 'Choose Your Income Range',
				occupation: 'Choose Your Occupation',
				dob: ''
			},
			verifyOptFormData: {
				otpAgent: '',
				phoneno: '',
				email: ''
			},
			signUpFormSubmitted: false,
			optVerified: false,
			loading: ''
		}
	},
	methods: {
		signUpSubmitAction (accountData) {
			authenticationApi
				.userVerification(accountData.username)
				.then((res) => {
					this.checkOtpOptionAndSendOtp(accountData)
				})
				.catch((e) => {
					this.resetRegisterFormData()
					//   $('#login-modal').modal('show');
					this.$router.push('/login')
				})
		},
		checkOtpOptionAndSendOtp (accountData) {
			let userAccountData = this.account
			if (accountData) {
				userAccountData = accountData
			}
			if (userAccountData.otpOption.toLowerCase() === 'email') {
				// call email otp service
				this.loading = authenticationApi
					.sendOTPEmail(userAccountData.username)
					.then((res) => {
						this.sendOtpSuccessCase(userAccountData)
					})
			} else if (userAccountData.otpOption.toLowerCase() === 'phone') {
				// call phone otp service
				this.loading = authenticationApi
					.sendOTP(userAccountData.phoneno)
					.then((res) => {
						this.sendOtpSuccessCase(userAccountData)
					})
			}
		},
		sendOtpSuccessCase (accountData) {
			this.signUpFormSubmitted = true
			this.account = accountData
			this.verifyOptFormData = {
				otpAgent: accountData.otpOption,
				phoneno: accountData.phoneno,
				email: accountData.username
			}
		},
		verifyOtp (optDetails) {
			if (optDetails.otpAgent.toLowerCase() === 'email') {
				// call email otp verification service
				this.loading = authenticationApi
					.verifyOTPEmail(optDetails.otp)
					.then((res) => {
						this.signUp()
					})
			} else if (optDetails.otpAgent.toLowerCase() === 'phone') {
				// call phone otp verification service
				this.loading = authenticationApi.verifyOTP(optDetails.otp).then((res) => {
					if (res.data.message === 'OTP Expired') {
						this.$toasted.show('Current OTP is Expired', {
							icon: 'exclamation-circle'
						})
					} else {
						this.signUp()
					}
				})
			}
		},
		resetRegisterFormData () {
			if (this.$route.query.next_to === 'home') {
				this.$router.push('/')
			} else if (this.$route.query.next_to === 'wishList') {
				// const productId = [];
				// productId.push(this.$route.query.product_id);
				//
				// productApi.getProductsByIds(productId)
				//   .then((res) => {
				//     if (res && res.data && res.data[0]) {
				//       this.addToWishlist(res.data[0]);
				//       customerApi.insertWishList().then(() => {
				this.$router.push({
					path: '/user/wish-list',
					query: {
						// next_to: 'user-wishlist',
						product_id: this.$route.query.product_id
					}
				})
			} else if (this.$route.query.next_to === 'checkOut') {
				this.$router.push({
					path: '/checkout'
				})
			} else {
				this.$router.push('/')
			}

			this.account = {
				firstname: '',
				lastname: '',
				username: '',
				password: '',
				phoneno: '',
				confirmPassword: '',
				otpOption: 'phone',
				checkbox: false
			}
			this.signUpFormSubmitted = false
			this.optVerified = false
			this.$root.$emit('SignUpFormClear')
			this.$root.$emit('ResetVerifyOtp')
			// $('#signin-modal').modal('hide');
		},
		signUp () {
			this.loading = authenticationApi
				.signUp(this.account)
				.then((res) => {
					if (res.status === 201) {
						this.resetRegisterFormData()
					}
				})
				.catch((e) => {
					if (e.status === 409) {
						this.resetRegisterFormData()
						// $('#login-modal').modal('show');
						this.$router.push('/login')
					}
				})
			// this.$router.push('/');
		}
	}
}
</script>
